export function getBiggestImageUrl(urls) {
    if (!urls) {
        return undefined;
    }
    const sortedEntries = Object.entries(urls).sort(([keyA], [keyB]) => {
        const sizeA = parseInt(keyA.split('X')[0], 10);
        const sizeB = parseInt(keyB.split('X')[0], 10);
        return sizeB - sizeA;
    });
    if (sortedEntries[0][0] === '1304X1072')
        return sortedEntries[1][1];
    return sortedEntries[0][1];
}
export function getSrcSet(urls) {
    let srcset = '';
    if (!urls) {
        return srcset;
    }
    const sortedEntries = Object.entries(urls).sort(([keyA], [keyB]) => {
        const sizeA = parseInt(keyA.split('X')[0], 10);
        const sizeB = parseInt(keyB.split('X')[0], 10);
        return sizeB - sizeA;
    });
    sortedEntries.forEach(([size, src]) => {
        srcset = srcset.concat(`${src} ${size.split('X')[0]}w, `);
    });
    return srcset.slice(0, -2);
}
//# sourceMappingURL=multiImage.js.map